import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";

Scrivito.provideEditingConfig("Video", {
  attributes: localizeAttrList(["tags"], "Video"),
  properties: ["tags"],
});
